import React, {Fragment, useState, useEffect} from "react" ;

import RAGStatus, {RagStatusValues} from "../ReactHookForm/ui/ReactRAGStatus";

import {useForm, Controller} from "react-hook-form";

import {updateQuestion} from "root/DataFunctions/SectionFns";
import { encodeStringForPost, decodeStringForPost } from "root/DataFunctions/BaseDataFns";

import './QuestionPane.scss';
import Check from "root/ReactHookForm/ui/Check";
import RightArrow from "root/ReactHookForm/ui/RightArrow";
import { AuditQuestionReviewStatus, AuditReviewStatus } from "root/DataFunctions/Constants";

const ErrorDiv = ({children}) =>
{
    const style = {marginTop: '5px', color: 'red'};

    return <div style={style}>{children}</div>
}

const MIN_RESPONSE_LENGTH = 10;

const QuestionPane = ( { record, onSubmitStatusChange, review_status }) =>
{
    const defaultAction = () =>
    {
        if( record.action === null || record.action === '')
        {
            return record.default_action;
        }
        else
        {
            const act = decodeStringForPost(record.action) ;

            return act ;
        }
    }

    const {register, control, handleSubmit, setValue, getValue, watch, formState: {errors}} = useForm(
        {
            defaultValues: {
                status: record.status,
                actionRequired: defaultAction(),
                evidence: decodeStringForPost(record.evidence)
            }});

    const [ submitted, setSubmitted ] = useState ( record.date_updated !== null ) ;

    const [ questionReviewStatus, setQuestionReviewStatus ] = useState ( +(record.review_status) )

    const watchStatus = watch("status", record.status);

    const needsReviewing = () =>
    {
        return review_status === AuditReviewStatus.IN_REVIEW && ( +watchStatus === 1 || +watchStatus === 2 ) ;
    }

    const isReviewUpdate = () =>
    {
        return review_status === AuditReviewStatus.IN_REVIEW ;
    }

    useEffect(() =>
    {
        if ( submitted )
        {
            if ( watchStatus === 3)
            {
                // Green
                setValue ( 'actionRequired', null);

            }
            else
            {
                setValue ( 'actionRequired', defaultAction());
            }
        }
        else
        {
            if ( watchStatus === 1 || watchStatus === 2 )
            {
                setValue ( 'actionRequired', defaultAction());
            }
            else
            {
                setValue ( 'actionRequired', null);
            }
        }
    }, [watchStatus]);

    const composeRef = () =>
    {
        const hasRef = record.section_ref !== null && record.question_ref !== null ;

        const refText = hasRef ? record.section_ref + '.' + record.question_ref + '. ' : '' ;

        return refText ;
    }

    const includePrompt = () =>
    {
        const isPrompt = record.prompt !== null;

        return (
            <Fragment>
                <div style={ { fontWeight: 'bold' } } dangerouslySetInnerHTML={ { __html: composeRef() + record.question_text } }/>
                { isPrompt && <br></br> }
                { isPrompt && <div dangerouslySetInnerHTML={ { __html: record.prompt } }/> }
            </Fragment>
        )
    }

    const doUpdate = (data) =>
    {
        const reviewSubmission = isReviewUpdate() ;

        const formData = {
            provider_table_response_id: record.provider_table_response_id,
            provider_table_section_id: record.provider_table_section_id,
            status: +data.status,
            is_review_submit: reviewSubmission,
            action: encodeStringForPost(data.actionRequired),
            evidence: encodeStringForPost(data.evidence)
        }

        updateQuestion ( 'current',  record.provider_table_section_id, record.provider_table_response_id,  formData, (response) =>
        {
            setSubmitted( true ) ;
            setQuestionReviewStatus ( AuditQuestionReviewStatus.REVIEW_SUBMITTED ) ;

            if ( onSubmitStatusChange !== undefined && onSubmitStatusChange !== null )
            {
                onSubmitStatusChange( record.table_question_id, true ) ;
            }
        } )
    }

    const onSubmit = (data) => {
        doUpdate (data) ;
    }

    const isInReview = () =>
    {
        if ( questionReviewStatus === AuditQuestionReviewStatus.IN_REVIEW )
        {
            return true ;
        }
        else
        {
            return false ;
        }
    }

    const submitButton = () =>
    {

        if ( submitted )
        {
            if ( isInReview() )
            {
                return (
                    <button type='submit' className="btn form-button"><span className='submit-button-text'>Re-Submit</span><RightArrow color={'green'} size='20px' /></button>
                )
            }
            else
            {
                return (
                    <button type='submit' className="btn form-button submitted"><span className='submit-button-text'>Submitted</span><Check color={'rgb(35, 234, 35)'} size='20px' /></button>
                )
            }
        }
        else
        {
            return (
                <button type='submit' className="btn form-button"><span className='submit-button-text'>Submit</span><RightArrow color={'green'} size='20px' />
                </button>
            )
        }
    }

    const validateRAG = ( val ) =>
    {
        if ( +val === RagStatusValues.UNSET )
        {
            return "You must select a RAG status" ;
        }
    }

    const errorBorderStyle = ( field ) =>
    {
        if ( errors[field] )
        {
            return ( ' error-box')
        }
        else
        {
            return '';
        }
    }

    const errorText = () =>
    {
        let text = '' ;

        if ( errors.evidence )
        {
            if ( errors.evidence.type === 'required' )
            {
                text += 'You must provide supporting evidence' ;
            }
            else
            {
                text += errors.evidence.message ;
            }
        }

        if ( errors.status )
        {
            text += text === '' ? ' You must select a RAG status' : ' - and a RAG status' ;
        }

        if ( errors.actionRequired )
        {
            text += text === '' ? '' : '. ' ;
            text += 'If you select Amber or Red status, you must provide an action.'
        }

        return text ;
    }

    const addStyle = () =>
    {
        switch ( review_status )
        {
            case AuditReviewStatus.IN_REVIEW:
                if ( submitted === true )
                {
                    if ( ( +watchStatus === 1 || +watchStatus === 2 ) )
                    {
                        return 'review' ;
                    }
                    else
                    {
                        return 'done' ;
                    }
                }
                else
                {
                    return '' ;
                }

            default:
                if ( submitted === true )
                {
                    return 'done' ;
                }
                else
                {
                    return '' ;
                }
        }
    }

    const commentDiv = () =>
    {
        if ( review_status === AuditReviewStatus.IN_REVIEW )
        {
            if ( +watchStatus === 1 || +watchStatus === 2 )
            {
                return <div className='comment'>Because you assessed your school as AMBER or RED last time, please review this question again, providing an update if appropriate.</div>
            }
        }
    }

    return (
        <Fragment>
                <div className='desktop-question'>
                    <div className={ 'question ' + addStyle() }>
                        <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>
                            <div className='row'>
                                <div className='col-md-4 c1'> {includePrompt()}</div>
                                <div className={'col-md-4' + errorBorderStyle('evidence')}>
                                    <label className='evidence-label' >Evidence</label>
                                    <textarea className='form-control' id='evidence' {...register("evidence", {required: true,
                                        validate: (value) =>
                                        {
                                            if ( [ 'yes', 'no', 'yes.', 'no.'  ].includes(value.toLowerCase().trim()))
                                            {
                                                return "Please provide more comprehensive evidence than just 'yes' or 'no'" ;
                                            }
                                            else if (value.toLowerCase().length < MIN_RESPONSE_LENGTH )
                                            {
                                                return "Please add more detail — Short responses are not sufficient evidence"
                                            }
                                        }
                                    })} />
                                </div>
                                <div className={'col-md-1' + errorBorderStyle('status')}>
                                    <label className='evidence-label' >Self Evaluation</label>
                                    <Controller
                                        control={control}
                                        name="status"
                                        rules={{ required: true, validate: validateRAG}}
                                        render={({
                                                     field: { onChange, onBlur, value, name, ref },
                                                     fieldState: { invalid, isTouched, isDirty, error },
                                                     formState,
                                                 }) => (
                                            <RAGStatus
                                                onBlur={onBlur} // notify when input is touched
                                                onChange={onChange} // send value to hook form
                                                value={value}
                                                inputRef={ref}
                                            />
                                        )}
                                    />
                                </div>
                                <div className='col-md-3' >
                                    <label className='evidence-label' >Action</label>
                                    <textarea className='form-control' id='actionRequired' {...register("actionRequired", {required: watchStatus === 1 || watchStatus === 2 })}></textarea>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    { errorText() !== '' && <ErrorDiv>{errorText()}</ErrorDiv>}
                                </div>
                            </div>

                            { /*errors.firstName && <ErrorDiv>This field is required</ErrorDiv> */}
                            { <div className='row'>
                                <div className='col-md-9'>{commentDiv()}</div>
                                <div className='col-md-3'>
                                    {submitButton()}
                                </div>
                            </div> }
                        </form>
                    </div>
                </div>
        </Fragment>
    )
}

export default QuestionPane;

